import { Flex, Text } from '@chakra-ui/react';
import { Button, Modal } from '@morressier/alembic';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/pro-light-svg-icons';

interface Props {
  onInvite: () => void;
  onClose: () => void;
  invitationDeadline: number;
  isLoading?: boolean;
}

const ConfirmIndividualInviteModal = ({
  onInvite,
  onClose,
  invitationDeadline,
  isLoading = false
}: Props) => {
  return (
    <Modal
      isOpen={true}
      onClose={onClose}
      width="448px"
      closeButtonProps={{ hidden: true }}
    >
      <Flex flexDirection="column" gap={6} padding={8}>
        <FontAwesomeIcon
          icon={faEnvelope}
          style={{ width: '40px', height: '40px' }}
          color="actionSecondaryCautionContent"
        />

        <Flex flexDirection="column" gap={2}>
          <Text textStyle="headingGroup">Invite Now?</Text>
          <Text textStyle="textBody">
            This Reviewer will be immediately invited, and will have{' '}
            {invitationDeadline} days to accept or decline the invitation.
            Invitations that miss the deadline will be registered as “Expired”.
          </Text>
          <Text textStyle="textBody">
            You will be able to edit the invitation template before inviting
            this Reviewer.
          </Text>
        </Flex>

        <Flex justifyContent="flex-end" gap={2}>
          <Button variant="secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button onClick={onInvite} disabled={isLoading} isLoading={isLoading}>
            Invite Now
          </Button>
        </Flex>
      </Flex>
    </Modal>
  );
};

export default ConfirmIndividualInviteModal;
